const prefix = '/api' as const;

export const noticeSegments = {
  noticeId: ':noticeId',
};

export const noticePaths = {
  list: `${prefix}/notices`,
  detail: (noticeId: string) => `${prefix}/notices/${noticeId}`,
} as const;
